import { render } from "./RainPlayerActive.vue?vue&type=template&id=cb82678a&scoped=true"
import script from "./RainPlayerActive.vue?vue&type=script&lang=js"
export * from "./RainPlayerActive.vue?vue&type=script&lang=js"

import "./RainPlayerActive.vue?vue&type=style&index=0&id=cb82678a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cb82678a"]])

export default __exports__